import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { ConsentService } from '@features/consent/services/consent.service';
import { WaitingRoomService } from '@features/waiting-room/services/waiting-room.service';
import { NavController } from '@ionic/angular/standalone';
import { WaitingRoomStatus } from '@swagger-services/waiting-room';

export const waitingRoomGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const preVideoSignatureKey = 'pre-video-visit';
  const consentService = inject(ConsentService);
  const navController = inject(NavController);
  const waitingRoomService = inject(WaitingRoomService);

  const hash = route.paramMap.get('hash')!;
  const waitingRoom = await waitingRoomService.getWaitingRoomFromHash(hash);

  if ([WaitingRoomStatus.WaitingForPayment, WaitingRoomStatus.Active].includes(waitingRoom!.status)) {
    const isSigned = await consentService.isGroupSigned(preVideoSignatureKey);
    if (isSigned) {
      return true;
    }
    await navController.navigateForward([`/waiting-room/${hash}/pre-video-visit`]);
    return false;
  }

  return true;
};
